import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "600"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.setRefreshInterval')))];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.timeIntMinutes
          },
          on: {
            "click": _vm.setTimeIntervalRefresh
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    staticClass: "device-form"
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mt-8",
    attrs: {
      "cols": "8",
      "md": "8"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.outlined,
      "filled": _vm.filled,
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.enterMinutesLabel'),
      "hide-details": "auto",
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "rules": _vm.requiredRule,
      "oninput": "validity.valid || (value='')",
      "required": "",
      "step": "1"
    },
    model: {
      value: _vm.timeIntMinutes,
      callback: function ($$v) {
        _vm.timeIntMinutes = _vm._n($$v);
      },
      expression: "timeIntMinutes"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };